import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

import applicationUserManager from "../Auth/applicationusermanager";

let base = '';
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';
// let base = process.env.NODE_ENV=="production"? 'http://baotingbusapi.hainancd.net':'';


// 请求延时
axios.defaults.timeout = 20000

var storeTemp = store;
axios.interceptors.request.use(
  config => {
    var curTime = new Date()
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))

    if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + storeTemp.state.token;
    }

    saveRefreshtime();

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let errInfo = { success: false, message: "错误" }
    // 超时请求处理
    var originalRequest = error.config;
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
      errInfo.message = "请求超时！";
      originalRequest._retry = true
    } else if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
          return refreshToken({ token: window.localStorage.Token }).then((res) => {
            if (res.success) {
              Vue.prototype.$message({
                message: 'refreshToken success! loading data...',
                type: 'success'
              });

              store.commit("saveToken", res.response.token);

              var curTime = new Date();
              var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in));
              store.commit("saveTokenExpire", expiredate);

              error.config.__isRetryRequest = true;
              error.config.headers.Authorization = 'Bearer ' + res.response.token;
              return axios(error.config);
            } else {
              // 刷新token失败 清除token信息并跳转到登录页面
              ToLogin()
            }
          });
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }

      }
      // 403 无权限
      else if (error.response.status == 403) {
        errInfo.message = "失败！该操作无权限";
      }
      // 429 ip限流
      else if (error.response.status == 429) {
        errInfo.message = "刷新次数过多，请稍事休息重试！";
      } else if (error.response.status == 404) {
        // 404 不存在
        errInfo.message = "失败！访问接口不存在";
      } else if (error.response.status == 500) {
        // 500 服务器异常
        errInfo.message = "失败！服务器异常";
      } else if (error.response.status == 405) {
        // 405 请求http方法错误
        errInfo.message = "失败！请求http方法错误";
      } else if (error.response.status == 415) {
        // 415 参数没有指定Body还是Query
        errInfo.message = "失败！参数没有指定Body还是Query";
      } else {
        //其他错误参数
        errInfo.message = '失败！请求错误' + error.response.status;
      }
    } else {
      errInfo.message = "失败！服务器断开";
    }
    Vue.prototype.$message({
      message: errInfo.message,
      type: 'error'
    });
    return errInfo; // 返回接口返回的错误信息
  }
);


export const BaseApiUrl = base;

// 登录
export const requestLogin = params => {
  return axios.get(`${base}/api/login/jwttoken3.0`, { params: params }).then(res => res.data);
};
export const requestLoginMock = params => { return axios.post(`${base}/login`, params).then(res => res.data); };

export const refreshToken = params => {
  return axios.get(`${base}/api/login/RefreshToken`, { params: params }).then(res => res.data);
};

export const saveRefreshtime = params => {

  let nowtime = new Date();
  let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1;//滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
    window.localStorage.refreshtime = lastRefreshtime;
  } else {
    window.localStorage.refreshtime = new Date(-1);
  }
};
const ToLogin = params => {

  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('NavigationBar');



  if (global.IS_IDS4) {
    applicationUserManager.login();
  } else {
    router.replace({
      path: "/login",
      query: { redirect: router.currentRoute.fullPath }
    });
    //window.location.reload()
  }
};

export const getUserByToken = params => {
  return axios.get(`${base}/api/user/getInfoByToken`, { params: params }).then(res => res.data);
};


export function testapi2() {
}

export const testapi = pa => {
}

// 用户管理
export const getUserListPage = params => {
  return axios.get(`${base}/api/user/get`, { params: params });
};
export const removeUser = params => {
  return axios.delete(`${base}/api/user/delete`, { params: params });
};
export const editUser = params => {
  return axios.put(`${base}/api/user/put`, params);
};
export const addUser = params => {
  return axios.post(`${base}/api/user/post`, params);
};
export const verifyLoginNameExist = params => {
  return axios.get(`${base}/api/user/VerifyLoginNameExist`, { params: params });
};
export const batchRemoveUser = params => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params });//没做
};

// 角色管理
export const getRoleListPage = params => {
  return axios.get(`${base}/api/role/get`, { params: params });
};
export const removeRole = params => {
  return axios.delete(`${base}/api/role/delete`, { params: params });
};
export const editRole = params => {
  return axios.put(`${base}/api/role/put`, params);
};
export const addRole = params => {
  return axios.post(`${base}/api/role/post`, params);
};

// 接口模块管理
export const getModuleListPage = params => {
  return axios.get(`${base}/api/module/get`, { params: params });
};
export const removeModule = params => {
  return axios.delete(`${base}/api/module/delete`, { params: params });
};
export const editModule = params => {
  return axios.put(`${base}/api/module/put`, params);
};
export const addModule = params => {
  return axios.post(`${base}/api/module/post`, params);
};

// 菜单模块管理
export const getPermissionListPage = params => {
  return axios.get(`${base}/api/permission/get`, { params: params });
};
export const getPermissionTreeTable = params => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params });
};
export const removePermission = params => {
  return axios.delete(`${base}/api/permission/delete`, { params: params });
};
export const editPermission = params => {
  return axios.put(`${base}/api/permission/put`, params);
};
export const addPermission = params => {
  return axios.post(`${base}/api/permission/post`, params);
};
export const getPermissionTree = params => {
  return axios.get(`${base}/api/permission/getpermissiontree`, { params: params });
};
export const getPermissionIds = params => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, { params: params });
};

export const addRolePermission = params => {
  return axios.post(`${base}/api/permission/Assign`, params);
};
export const getNavigationBar = params => {
  return axios.get(`${base}/api/permission/GetNavigationBar`, { params: params }).then(res => res.data);
};

// 字典管理
export const getTreeTableListPage = params => {
  return axios.get(`${base}/api/dictionary/getTreeTable`, { params: params });
};
export const getDictionaryListPageByDictNameAndDictCode = params => {
  return axios.get(`${base}/api/dictionary/getDictionaryByDictNameAndDictCode`, { params: params });
};
export const getDictionaryListPageByPid = params => {
  return axios.get(`${base}/api/dictionary/getDictionaryByPid`, { params: params });
};
export const verifyDictNameExist = params => {
  return axios.get(`${base}/api/dictionary/VerifyDictNameExist`, { params: params });
};
export const verifyDictCodeExist = params => {
  return axios.get(`${base}/api/dictionary/VerifyDictCodeExist`, { params: params });
};
export const getClassSubitem = params => {
  return axios.get(`${base}/api/dictionary/getClassSubitem`);
};
export const getDictionaryItem = params => {
  return axios.get(`${base}/api/dictionary/getDictionaryItem`, { params: params });
};
export const addDictionary = params => {
  return axios.post(`${base}/api/dictionary/post`, params);
};
export const editDictionary = params => {
  return axios.put(`${base}/api/dictionary/put`, params);
};
export const removeDictionary = params => {
  return axios.delete(`${base}/api/dictionary/delete`, { params: params });
};

// 企业管理
export const getCompanyListPage = params => {
  return axios.get(`${base}/api/company/get`, { params: params });
};
export const addCompany = params => {
  return axios.post(`${base}/api/company/post`, params);
};
export const editCompany = params => {
  return axios.put(`${base}/api/company/put`, params);
};
export const removeCompany = params => {
  return axios.delete(`${base}/api/company/delete`, { params: params });
};

// 公交线路管理
export const getBusLinesListPage = params => {
  return axios.get(`${base}/api/busLines/get`, { params: params });
};
export const verifyLineChineseNameExist = params => {
  return axios.get(`${base}/api/busLines/verifyLineChineseNameExist`, { params: params });
};
export const verifyLineEnglishNameExist = params => {
  return axios.get(`${base}/api/busLines/verifyLineEnglishNameExist`, { params: params });
};
export const addBusLines = params => {
  return axios.post(`${base}/api/busLines/post`, params);
};
export const editBusLines = params => {
  return axios.put(`${base}/api/busLines/put`, params);
};
export const removeBusLines = params => {
  return axios.delete(`${base}/api/busLines/delete`, { params: params });
};

// 车辆管理
export const getVehiclesListPage = params => {
  return axios.get(`${base}/api/vehicles/get`, { params: params });
};
export const getAllVehiclesData = params => {
  return axios.get(`${base}/api/vehicles/GetAllVehiclesData`, { params: params });
};
export const getByDriverIdVehiclesData = params => {
  return axios.get(`${base}/api/vehicles/getByDriverIdVehiclesData`, { params: params });
};
export const initVehiclesData = params => {
  return axios.get(`${base}/api/vehicles/initVehiclesData`, { params: params });
};
export const addVehicles = params => {
  return axios.post(`${base}/api/vehicles/post`, params);
};
export const getLastTerminalsInfoData = params => {
  return axios.post(`${base}/api/vehicles/getLastTerminalsInfoData`, params);
};
export const editVehicles = params => {
  return axios.put(`${base}/api/vehicles/put`, params);
};
export const removeVehicles = params => {
  return axios.delete(`${base}/api/vehicles/delete`, { params: params });
};

// 驾驶员管理
export const getDriverListPage = params => {
  return axios.get(`${base}/api/driver/get`, { params: params });
};
export const addDriver = params => {
  return axios.post(`${base}/api/driver/post`, params);
};
export const editDriver = params => {
  return axios.put(`${base}/api/driver/put`, params);
};
export const removeDriver = params => {
  return axios.delete(`${base}/api/driver/delete`, { params: params });
};

// 站点管理
export const getSiteListPage = params => {
  return axios.get(`${base}/api/site/get`, { params: params });
};
export const getBusLineDirectionByBusLinesId = params => {
  return axios.get(`${base}/api/site/GetBusLineDirectionByBusLinesId`, { params: params });
};
export const getSiteDataByBusLinesId = params => {
  return axios.get(`${base}/api/site/GetSiteDataByBusLinesId`, { params: params });
};
export const addSite = params => {
  return axios.post(`${base}/api/site/post`, params);
};
export const batchAddSiteData = params => {
  return axios.post(`${base}/api/site/batchAddSiteData`, params);
};
export const editSite = params => {
  return axios.put(`${base}/api/site/put`, params);
};
export const removeSite = params => {
  return axios.delete(`${base}/api/site/delete`, { params: params });
};
export const importSiteData = params => {
  return axios.post(`${base}/api/site/ImportSiteData`, params);
};
export const SaveExcel = params => {
  return axios.get(`${base}/api/site/SaveExcel`);
};

export const importSiteDataUrl = `${base}/api/site/ImportSiteData`;

// 公交线路班车时间管理
export const getBusLineShiftTimePage = params => {
  return axios.get(`${base}/api/busLineShiftTime/get`, { params: params });
};
export const addBusLineShiftTime = params => {
  return axios.post(`${base}/api/busLineShiftTime/post`, params);
};
export const editBusLineShiftTime = params => {
  return axios.put(`${base}/api/busLineShiftTime/put`, params);
};
export const removeBusLineShiftTime = params => {
  return axios.delete(`${base}/api/busLineShiftTime/delete`, { params: params });
};

// 班次管理
export const getShiftListPage = params => {
  return axios.get(`${base}/api/shift/get`, { params: params });
};
export const getDistinctShiftNameListByBusLinesId = params => {
  return axios.get(`${base}/api/shift/getDistinctShiftNameListByBusLinesId`, { params: params });
};
export const addShift = params => {
  return axios.post(`${base}/api/shift/post`, params);
};
export const editShift = params => {
  return axios.put(`${base}/api/shift/put`, params);
};
export const editReplaceShift = params => {
  return axios.put(`${base}/api/shift/putReplace`, params);
};
export const removeShift = params => {
  return axios.delete(`${base}/api/shift/delete`, { params: params });
};

// 排班模版管理
export const getSchedulingTemplateListPage = params => {
  return axios.get(`${base}/api/schedulingTemplate/get`, { params: params });
};
export const addSchedulingTemplate = params => {
  return axios.post(`${base}/api/schedulingTemplate/post`, params);
};
export const editSchedulingTemplate = params => {
  return axios.put(`${base}/api/schedulingTemplate/put`, params);
};
export const removeSchedulingTemplate = params => {
  return axios.delete(`${base}/api/schedulingTemplate/delete`, { params: params });
};

// 发车时间管理
export const getDepartureTimeListPage = params => {
  return axios.get(`${base}/api/departureTime/get`, { params: params });
};
export const addDepartureTime = params => {
  return axios.post(`${base}/api/departureTime/post`, params);
};
export const editDepartureTime = params => {
  return axios.put(`${base}/api/departureTime/put`, params);
};
export const removeDepartureTime = params => {
  return axios.delete(`${base}/api/departureTime/delete`, { params: params });
};

// 线路人车绑定管理
export const getLineManVehicleListPage = params => {
  return axios.get(`${base}/api/lineManVehicle/get`, { params: params });
};
export const getLineManVehicleViewModels = params => {
  return axios.get(`${base}/api/lineManVehicle/getLineManVehicleViewModels`);
};
export const exportExcel = params => {
  return axios.get(`${base}/api/lineManVehicle/exportExcel`, { params: params, responseType: "blob" });
};
export const editLineManVehicle = params => {
  return axios.put(`${base}/api/lineManVehicle/put`, params);
};
export const putBindingVehiclesList = params => {
  return axios.put(`${base}/api/lineManVehicle/putBindingVehiclesList`, params);
};
export const putEditBindingVehiclesList = params => {
  return axios.put(`${base}/api/lineManVehicle/putEditBindingVehiclesList`, params);
};
export const cancelLineManVehicleBinding = params => {
  return axios.put(`${base}/api/lineManVehicle/cancelLineManVehicleBinding`, params);
};
export const editVehicleLineDriver = params => {
  return axios.put(`${base}/api/lineManVehicle/putDriver`, params);
};
export const editVehicleLineVehicle = params => {
  return axios.put(`${base}/api/lineManVehicle/putVehicle`, params);
};

// 首次排班依据管理
export const getVehicleLineListPage = params => {
  return axios.get(`${base}/api/vehicleLine/get`, { params: params });
};
export const getSchedulingBasisViewModels = params => {
  return axios.get(`${base}/api/vehicleLine/getSchedulingBasisViewModels`, { params: params });
};
export const vehicleLineExportExcel = params => {
  return axios.get(`${base}/api/vehicleLine/vehicleLineExportExcel`, { params: params, responseType: "blob" });
};
export const verifyShiftName = params => {
  return axios.get(`${base}/api/vehicleLine/VerifyShiftName`, { params: params });
};
export const editVehicleLine = params => {
  return axios.put(`${base}/api/vehicleLine/put`, params);
};
export const editReplaceVehicleLine = params => {
  return axios.put(`${base}/api/vehicleLine/EditReplace`, params);
};
export const cancelScheduling = params => {
  return axios.put(`${base}/api/vehicleLine/CancelScheduling`, params);
};

// 排班管理
export const getSchedulingListPage = params => {
  return axios.get(`${base}/api/Scheduling/get`, { params: params });
};
export const getBusLinesIdDriverIdList = params => {
  return axios.get(`${base}/api/Scheduling/getBusLinesIdDriverIdList`, { params: params });
};
export const exportScheduling = params => {
  return axios.get(`${base}/api/Scheduling/exportScheduling`, { params: params, responseType: "blob" });
};
export const getSchedulingRuleData = params => {
  return axios.get(`${base}/api/Scheduling/getSchedulingRuleData`, { params: params });
};
export const addScheduling = params => {
  return axios.post(`${base}/api/Scheduling/post`, params);
};
export const previewScheduling = params => {
  return axios.post(`${base}/api/Scheduling/preview`, params);
};
export const editScheduling = params => {
  return axios.put(`${base}/api/Scheduling/put`, params);
};
export const editSchedulingShiftName = params => {
  return axios.put(`${base}/api/Scheduling/editSchedulingShiftName`, params);
};
export const editSchedulingBusLinesIdAndShiftName = params => {
  return axios.put(`${base}/api/Scheduling/editSchedulingBusLinesIdAndShiftName`, params);
};
export const clearScheduling = params => {
  return axios.delete(`${base}/api/Scheduling/clearScheduling`, { params: params });
};
export const deleteScheduling = params => {
  return axios.put(`${base}/api/Scheduling/deleteScheduling`, params);
};

// 每日排班管理
export const getEveryDaySchedulingListPage = params => {
  return axios.get(`${base}/api/EveryDayScheduling/get`, { params: params });
};
export const cancelTask = params => {
  return axios.put(`${base}/api/EveryDayScheduling/cancelTask`, params);
};
export const recoverTask = params => {
  return axios.put(`${base}/api/EveryDayScheduling/recoverTask`, params);
};
export const editSchedulingTask = params => {
  return axios.put(`${base}/api/EveryDayScheduling/editSchedulingTask`, params);
};
export const addSchedulingTask = params => {
  return axios.put(`${base}/api/EveryDayScheduling/addSchedulingTask`, params);
};
export const editShiftAdjustment = params => {
  return axios.put(`${base}/api/EveryDayScheduling/editShiftAdjustment`, params);
};
export const addeverScheduling = params => {
  return axios.post(`${base}/api/EveryDayScheduling/post`, params);
};
export const addCharterTask = params => {
  return axios.post(`${base}/api/EveryDayScheduling/addCharterTask`, params);
};
export const getShiftNameListPage = params => {
  return axios.get(`${base}/api/EveryDayScheduling/getShiftNameListPage`, { params: params });
};

// 运行中心任务管理
export const getRunCenterTaskListPage = params => {
  return axios.get(`${base}/api/RunCenterTask/get`, { params: params });
};
export const exportRunCenterTask = params => {
  return axios.get(`${base}/api/RunCenterTask/Export`, { params: params, responseType: "blob" });
};
export const addRunCenterTask = params => {
  return axios.post(`${base}/api/RunCenterTask/post`, params);
};
export const postRunCenterTask = params => {
  return axios.post(`${base}/api/RunCenterTask/postRunCenterTask`, params);
};
export const editRunCenterTask = params => {
  return axios.put(`${base}/api/RunCenterTask/put`, params);
};
export const runCenterCancelTaskByShiftName = params => {
  return axios.put(`${base}/api/RunCenterTask/cancelTaskByShiftName`, params);
};
export const runCenterRecoverTaskByShiftName = params => {
  return axios.put(`${base}/api/RunCenterTask/recoverTaskByShiftName`, params);
};
export const runCenterCancelSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/cancelSingleTask`, params);
};
export const runCenterRecoverSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/recoverSingleTask`, params);
};
export const runCenterChangeVehicleSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/changeVehicleSingleTask`, params);
};
export const runCenterChangeDriverSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/changeDriverSingleTask`, params);
};
export const runCenterChangeDepartureTimeStrSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/changeDepartureTimeStrSingleTask`, params);
};
export const runCenterChangeCharterSingleTask = params => {
  return axios.put(`${base}/api/RunCenterTask/changeCharterSingleTask`, params);
};
export const runCenterCharterTask = params => {
  return axios.put(`${base}/api/RunCenterTask/charterTask`, params);
};
export const runCenterCancelCharterTask = params => {
  return axios.put(`${base}/api/RunCenterTask/cancelCharterTask`, params);
};
export const runCenteraddCharterTask = params => {
  return axios.post(`${base}/api/RunCenterTask/addRunCenterCharterTask`, params);
};
export const RunCenterTaskAbnormalDisposeUser = params => {
  return axios.put(`${base}/api/RunCenterTask/AbnormalDispose`, params);
};

// 司机里程管理
export const getDriverMileageModels = params => {
  return axios.get(`${base}/api/DriverMileage/getDriverMileageModels`, { params: params });
};
export const getDriverMileageListPage = params => {
  return axios.get(`${base}/api/DriverMileage/get`, { params: params });
};
export const exportDriverMileage = params => {
  return axios.get(`${base}/api/DriverMileage/exportDriverMileage`, { params: params, responseType: "blob" });
};
export const makeUpDriverMileage = params => {
  return axios.post(`${base}/api/DriverMileage/makeUpDriverMileage`, params);
};

// 统计中心管理
export const getStatisticsCentreViewModels = params => {
  return axios.get(`${base}/api/statisticsCentre/getStatisticsCentreViewModels`, { params: params });
};
export const getStatisticsCentreListPage = params => {
  return axios.get(`${base}/api/statisticsCentre/get`, { params: params });
};
export const exportStatisticsCentre = params => {
  return axios.get(`${base}/api/statisticsCentre/exportStatisticsCentre`, { params: params, responseType: "blob" });
};

// 统计明细管理
export const getTotalDetailsViewModels = params => {
  return axios.get(`${base}/api/totalDetails/getTotalDetailsViewModels`, { params: params });
};
export const getTotalDetailsListPage = params => {
  return axios.get(`${base}/api/totalDetails/get`, { params: params });
};
export const exportTotalDetails = params => {
  return axios.get(`${base}/api/totalDetails/exportTotalDetails`, { params: params, responseType: "blob" });
};
export const AbnormalDisposeUser = params => {
  return axios.put(`${base}/api/totalDetails/AbnormalDispose`, params);
};

// 操作日记管理
export const getOperateDataLogListPage = params => {
  return axios.get(`${base}/api/operateDataLog/get`, { params: params });
};
export const getTwoTableOperateDataLogListPage = params => {
  return axios.get(`${base}/api/operateDataLog/GetTwoTableOperateDataLogListPage`, { params: params });
};
export const getSubOperateDataLogListPage = params => {
  return axios.get(`${base}/api/operateDataLog/getSubOperateDataLogListPage`, { params: params });
};

// 百度管理
export const baiduTrans = params => {
  return axios.get(`${base}/api/Baidu/Trans`, { params: params });
};

// Bug模块管理
export const getBugListPage = params => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params });
};
export const removeBug = params => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params });
};
export const editBug = params => {
  return axios.put(`${base}/api/TopicDetail/update`, params);
};
export const addBug = params => {
  return axios.post(`${base}/api/TopicDetail/post`, params);
};


// 博客模块管理
export const getBlogListPage = params => {
  return axios.get(`${base}/api/Blog`, { params: params });
};
export const getBlogDeatil = params => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params });
};
export const editBlog = params => {
  return axios.put(`${base}/api/Blog/update`, params);
};
export const removeBlog = params => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params });
};

// 日志
export const getLogs = params => {
  return axios.get(`${base}/api/Monitor/get`, { params: params });
};
export const getRequestApiinfoByWeek = params => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, { params: params });
};
export const getAccessApiByDate = params => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, { params: params });
};
export const getAccessApiByHour = params => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, { params: params });
};
export const getServerInfo = params => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params });
};
export const getAccessLogs = params => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params });
};
export const getIds4UsersGrow = params => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params });
};
export const getActiveUsers = params => {
  return axios.get(`${base}/api/Monitor/GetActiveUsers`, { params: params });
};


// Task管理
export const getTaskListPage = params => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params });
};
export const removeTask = params => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params });
};
export const editTask = params => {
  return axios.put(`${base}/api/TasksQz/put`, params);
};
export const addTask = params => {
  return axios.post(`${base}/api/TasksQz/post`, params);
};

export const startJob = params => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params });
};
export const stopJob = params => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params });
};
export const reCovery = params => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params });
};
export const pauseJob = params => {
  return axios.get(`${base}/api/TasksQz/PauseJob`, { params: params });
};
export const resumeJob = params => {
  return axios.get(`${base}/api/TasksQz/ResumeJob`, { params: params });
};
export const getTaskNameSpace = params => {
  return axios.get(`${base}/api/TasksQz/GetTaskNameSpace`, { params: params });
};

// ids4
export const getAchieveUsers_IS4 = params => {
  return axios.get(`${base}/is4api/GetAchieveUsers`, { params: params });
};


//微信公众号
export const getWeChatAccount = params => {
  return axios.get(`${base}/api/WeChatConfig/get`, { params: params });
};
export const removeWeChatAccount = params => {
  return axios.delete(`${base}/api/WeChatConfig/delete`, { params: params });
};
export const batchDeleteChatAccount = params => {
  return axios.delete(`${base}/api/WeChatConfig/BatchDelete`, { params: params });
};
export const addWeChatAccount = params => {
  return axios.post(`${base}/api/WeChatConfig/post`, params);
};
export const updateWeChatAccount = params => {
  return axios.put(`${base}/api/WeChatConfig/put`, params);
};
export const getWeChatTemplate = params => {
  return axios.get(`${base}/api/WeChat/GetTemplate`, { params: params });//获取模板
};
export const refreshWeChatToken = params => {
  return axios.get(`${base}/api/WeChat/RefreshToken`, { params: params });//更新Token
};
export const getWeChatMenu = params => {
  return axios.get(`${base}/api/WeChat/GetMenu`, { params: params });//获取微信菜单
};
export const updateWeChatMenu = params => {
  return axios.put(`${base}/api/WeChat/updateMenu`, params);//更新微信菜单
};
export const getWeChatCompany = params => {
  return axios.get(`${base}/api/WeChatCompany/get`, { params: params });
};
export const removeWeChatCompany = params => {
  return axios.delete(`${base}/api/WeChatCompany/delete`, { params: params });
};
export const batchDeleteWeChatCompany = params => {
  return axios.delete(`${base}/api/WeChatCompany/BatchDelete`, { params: params });
};
export const addWeWeChatCompany = params => {
  return axios.post(`${base}/api/WeChatCompany/post`, params);
};
export const updateWeChatCompany = params => {
  return axios.put(`${base}/api/WeChatCompany/put`, params);
};
export const getWeChatPushLog = params => {
  return axios.get(`${base}/api/WeChatPushLog/get`, { params: params });
};
export const getWeChatSubUser = params => {
  return axios.get(`${base}/api/WeChat/GetSubUsers`, { params: params });
};
export const getWeChatBindUser = params => {
  return axios.get(`${base}/api/WeChatSub/get`, { params: params });
};
export const pushTestMsg = params => {
  return axios.post(`${base}/api/WeChat/PushTxtMsg`, params);
};
export const pushCardMsg = params => {
  return axios.post(`${base}/api/WeChat/PushCardMsg`, params);
};